// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getEventos as listEventosAPI,
    getEvento as getEventoAPI,
    addEvento as addEventoAPI,
    updateEvento as updateEventoAPI,
    deleteEvento as deleteEventoAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { eventosApiResponseError, eventosApiResponseSuccess } from './actions';
import { EventosActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getEvento({ payload: { id } }) {
    try {
        const response = yield call(getEventoAPI, id );
        const eventoItem = response.data.data;
        yield put(eventosApiResponseSuccess(EventosActionTypes.GET_EVENTO, eventoItem));
    } catch (error) {
        yield put(eventosApiResponseError(EventosActionTypes.GET_EVENTO, error));
    }
}

function* addEvento({payload:evento}){
    try{
        const response = yield call(addEventoAPI,{...evento})
        const eventoItem = response.data
        yield put(eventosApiResponseSuccess(EventosActionTypes.ADD_EVENTO,eventoItem))
    } catch(error){
        yield put(eventosApiResponseError(EventosActionTypes.ADD_EVENTO,error))
    }
}

function* updateEvento({payload:evento}){
    try{
        const response = yield call(updateEventoAPI,{...evento})
        const eventoItem = response.data.data
        yield put(eventosApiResponseSuccess(EventosActionTypes.UPDATE_EVENTO,eventoItem))
    }catch(error){
        yield put(eventosApiResponseError(EventosActionTypes.UPDATE_EVENTO,error))
    }
}
function* deleteEvento({payload:{id}}){
    try{
        const response = yield call(deleteEventoAPI,id)
        const eventoItem = response.data.id
        yield put(eventosApiResponseSuccess(EventosActionTypes.DELETE_EVENTO,eventoItem))
    }catch(error){
        yield put(eventosApiResponseError(EventosActionTypes.DELETE_EVENTO,error))
    }
}

/**
 * List contactos
 */
function* listEventos({payload:params}) {
    try {
        const response = yield call(listEventosAPI, { ...params });
        const listaEventos = response.data.data;
        yield put(eventosApiResponseSuccess(EventosActionTypes.LIST_EVENTOS, listaEventos));
    } catch (error) {
        yield put(eventosApiResponseError(EventosActionTypes.LIST_EVENTOS, error));
    }
}


export function* watchGetEvento(): any {
    yield takeEvery(EventosActionTypes.GET_EVENTO, getEvento);
}

export function* watchListEventos(): any {
    yield takeEvery(EventosActionTypes.LIST_EVENTOS, listEventos);
}

export function* watchAddEvento():any{
    yield takeEvery(EventosActionTypes.ADD_EVENTO,addEvento)
}
export function* watchUpdateEvento():any{
    yield takeEvery(EventosActionTypes.UPDATE_EVENTO,updateEvento)
}
export function* watchDeleteEvento():any{
    yield takeEvery(EventosActionTypes.DELETE_EVENTO,deleteEvento)
}


function* eventosSaga(): any {
    yield all([
        fork(watchGetEvento),
        fork(watchListEventos),
        fork(watchAddEvento),
        fork(watchUpdateEvento),
        fork(watchDeleteEvento),
    ]);
}

export default eventosSaga;
